import { useCallback, useEffect } from "react";
import { MenteeWallView } from "@/components/wall/wall-panel";
import { useAckWallBadges } from "@/lib/api/walls";
import { PostHogEvents, useTrackEvent } from "@/lib/posthog-events";

export function ProfileTab({
  mentorshipId,
  menteeId,
  menteeName,
}: {
  mentorshipId: string | null;
  menteeId: string | null;
  menteeName: string | null;
}) {
  const ackBadges = useAckWallBadges(mentorshipId);
  const { track } = useTrackEvent();

  useEffect(() => {
    if (!mentorshipId || !menteeId) return;
    track(PostHogEvents.MENTOR_PROFILE_VIEWED, {
      teen_id: menteeId,
      mentorship_id: mentorshipId,
    });
  }, [menteeId, mentorshipId, track]);

  const ack = useCallback(
    (key: string) => ackBadges.mutate([key]),
    [ackBadges],
  );
  const clearAll = useCallback(() => ackBadges.mutate("all"), [ackBadges]);

  if (!mentorshipId) return null;

  return (
    <MenteeWallView
      mentorshipId={mentorshipId}
      menteeName={menteeName ?? ""}
      onAcknowledge={ack}
      onClearAll={clearAll}
    />
  );
}
